<template>
  <footer>
    <cookie-law theme="dark-lime">
      <div slot-scope="props">
         <p>
            {{ $t('texts._cookies_law_1') }}.
            {{ $t('texts._cookies_law_2') }}.
            {{ $t('texts._cookies_law_3') }}
         <v-btn class="secondary" @click="props.accept">{{ $t('texts._cookies_law_accept') }}</v-btn>&nbsp;
         <v-btn class="warning" @click="props.close">{{ $t('texts._cookies_law_deny') }}</v-btn>
         </p>
      </div>       
    </cookie-law>
  </footer>
</template>

<script>
   import Vue from 'vue';
   import i18n from '@/plugins/i18n.js';
   import CookieLaw from 'vue-cookie-law'
   export default {
      components: { CookieLaw }
   }
</script>